import { gql, useMutation } from '@apollo/client';
import { useShareTokenJwt } from '@app/hooks/useShareTokenJwt';

const ESCALATE_SERVICE_CHECK = gql`
  mutation EscalateServiceCheck($id: ID!, $token: String) {
    escalateServiceCheck(id: $id, token: $token) {
      id
      escalatedAt
    }
  }
`;

export interface EscalateServiceCheckVariables {
  id: string;
  token?: string | null;
}

export interface EscalateServiceCheckData {
  escalateServiceCheck: {
    id: string;
    escalatedAt: string | null;
  };
}

export function useEscalateServiceCheckMutation() {
  const { token } = useShareTokenJwt();
  const [mutate, result] = useMutation<EscalateServiceCheckData, EscalateServiceCheckVariables>(ESCALATE_SERVICE_CHECK);
  const wrapped: typeof mutate = (options) =>
    mutate({ ...options, variables: { ...(options?.variables as EscalateServiceCheckVariables), token } });
  return [wrapped, result] as const;
}
